var _circle, _rect, _path, _circle2, _circle3, _circle4, _path2, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMairaAdvisorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#00A4C8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 18,
    width: 32,
    height: 24,
    rx: 6,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 42l4 6v-6h-4z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 30,
    r: 2.5,
    fill: "#00A4C8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 30,
    r: 2.5,
    fill: "#00A4C8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 30,
    r: 2.5,
    fill: "#00A4C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14c0-2 1.5-4 4-4h20c2.5 0 4 2 4 4",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 8,
    r: 2,
    fill: "#fff",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMairaAdvisorIcon);
export default __webpack_public_path__ + "static/media/maira-advisor-icon.5ba3e799fe9d5233b3f238bc47070cc5.svg";
export { ForwardRef as ReactComponent };